import apiClient from './client'

export interface SpecificationInterface {
  id: number
  specification_id: number
  interface_type_id: number
  chassis_label: string
  os_name?: string
  interface_type_name?: string
  interface_type_code?: string
  interface_type_category?: string
  created_at?: string
  updated_at?: string
}

export const getSpecificationInterfaces = async (specificationId: number): Promise<SpecificationInterface[]> => {
  const response = await apiClient.get('/api/specification_interfaces', {
    params: { specification_id: specificationId }
  })
  if (Array.isArray(response.data)) {
    return response.data
  }
  if (response?.data && response.data.success) {
    return response.data.data
  }
  throw new Error('Failed to fetch specification interfaces')
}

export const createSpecificationInterface = async (
  data: Omit<SpecificationInterface, 'id' | 'created_at' | 'updated_at'>
): Promise<SpecificationInterface> => {
  const response = await apiClient.post('/api/specification_interfaces', data)
  if (response?.data && typeof response.data === 'object' && 'id' in response.data) {
    return response.data as unknown as SpecificationInterface
  }
  if (response?.data && response.data.success) {
    return response.data.data
  }
  throw new Error('Failed to create specification interface')
}

export const updateSpecificationInterface = async (
  id: number,
  data: Partial<SpecificationInterface>
): Promise<void> => {
  await apiClient.put(`/api/specification_interfaces/${id}`, data)
}

export const deleteSpecificationInterface = async (id: number): Promise<void> => {
  await apiClient.delete(`/api/specification_interfaces/${id}`)
}
